/* ===========================================================
   Madagascar Pet Shop — comportamiento del theme
   Port del prototipo aprobado (01-ECOMMERCE/diseño/assets/shop.js) sobre Shopify:
   el carrito y el checkout son los NATIVOS (Dawn: <cart-drawer>), no localStorage.
   Lo que sigue en el navegador: favoritos (por handle), filtro de mascota y filtros
   de la tienda, igual que en la vista previa.
   =========================================================== */
(function () {
  const $ = (s, el) => (el || document).querySelector(s);
  const $$ = (s, el) => [...(el || document).querySelectorAll(s)];
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const fmt = (n) => '$' + Math.round(Number(n)).toLocaleString('es-CL').replace(/,/g, '.');
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };
  const ICON = {
    wa: '<svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.7 1-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5L9 6.6c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.3M12 0C5.5 0 .2 5.3.2 11.9c0 2.1.5 4.1 1.6 5.9L0 24l6.3-1.7a11.9 11.9 0 0 0 5.7 1.5c6.5 0 11.9-5.3 11.9-11.9C23.9 5.3 18.6 0 12 0z"/></svg>',
    close: '<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    filtro: '<svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h18M6 12h12M10 19h4"/></svg>',
  };

  /* ---------- estado del navegador ---------- */
  let favs = store.get('md_favs_h', []);
  let pet = store.get('md_pet', 'todos');
  const saveFavs = () => store.set('md_favs_h', favs);

  /* ---------- toast ---------- */
  let toastT;
  function toast(msg, accion) {
    const t = $('#toast'); if (!t) return;
    $('#toastMsg').textContent = msg;
    const a = $('#toastAction');
    a.innerHTML = accion ? `<a href="${accion.href}">${esc(accion.texto)}</a>` : '';
    a.style.display = accion ? 'inline-flex' : 'none';
    t.classList.add('md-show'); clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('md-show'), accion ? 4000 : 2200);
  }

  /* ---------- overlays (menú y vista rápida) ---------- */
  const FOCUSABLE = 'button:not([disabled]),a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])';
  let lastFocus = null;
  function open(el, bg) {
    lastFocus = document.activeElement;
    const node = document.getElementById(el);
    document.getElementById(bg).classList.add('md-open'); node.classList.add('md-open');
    node.removeAttribute('inert'); document.body.style.overflow = 'hidden';
    const f = node.querySelector(FOCUSABLE); if (f) f.focus();
  }
  function close(el, bg) {
    const node = document.getElementById(el); if (!node) return;
    document.getElementById(bg).classList.remove('md-open'); node.classList.remove('md-open');
    node.setAttribute('inert', ''); document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus(); lastFocus = null;
  }
  const menu = (o) => (o ? open('menu', 'menuBg') : close('menu', 'menuBg'));

  /* ---------- desplegable "Tienda" ---------- */
  function drop(forzar) {
    const btn = $('#dropBtn'), panel = $('#dropPanel'); if (!btn || !panel) return;
    const abrir = forzar === undefined ? panel.hidden : forzar;
    panel.hidden = !abrir;
    btn.setAttribute('aria-expanded', String(abrir));
    btn.classList.toggle('md-open', abrir);
  }

  /* ---------- carrito nativo ---------- */
  // Mismo contrato que product-form.js de Dawn: /cart/add.js con las secciones del
  // carrito lateral y del ícono, y <cart-drawer>.renderContents() las pinta y lo abre.
  async function add(variantId, qty, nombre, btn) {
    if (btn) { btn.style.transform = 'scale(.8)'; setTimeout(() => (btn.style.transform = ''), 150); }
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (drawer) { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = location.pathname; }
    try {
      const r = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
      });
      const data = await r.json();
      if (!r.ok || data.status) { toast(data.description || data.message || 'No pudimos agregar el producto'); return; }
      toast(`${nombre || 'Producto'} agregado`);
      if (drawer) { data.id = Number(variantId); drawer.classList.remove('is-empty'); drawer.renderContents(data); syncRegalos(true); }
      else location.href = (window.routes && window.routes.cart_url) || '/cart';
    } catch (e) { toast('No pudimos agregar el producto'); }
  }

  /* ---------- favoritos ---------- */
  function syncFavs() { $$('[data-md-fav]').forEach((b) => b.classList.toggle('md-on', favs.includes(b.dataset.mdFav))); }
  function fav(handle, btn) {
    const i = favs.indexOf(handle), quitando = i >= 0;
    if (quitando) favs.splice(i, 1); else favs.push(handle);
    saveFavs(); if (btn) btn.classList.toggle('md-on', !quitando);
    toast(quitando ? 'Quitado de favoritos' : `Guardado en favoritos (${favs.length})`,
      quitando ? null : { texto: 'Ver', href: '/collections/all?fav=1' });
    document.dispatchEvent(new CustomEvent('md:favs'));
  }

  /* ---------- vista rápida ---------- */
  let qvState = null;
  async function qv(handle) {
    const box = $('#qv'); if (!box) return;
    const card = document.querySelector(`.md-card[data-handle="${CSS.escape(handle)}"]`);
    let p;
    try { p = await (jsonCache[handle] || fetch(`/products/${handle}.js`).then((r) => r.json())); if (!p) throw 0; }
    catch (e) { location.href = `/products/${handle}`; return; }
    const v = p.variants.find((x) => x.available) || p.variants[0];
    const nombre = (card && card.dataset.name) || p.title.split(' | ')[0].split(' — ')[0];
    const tmp = document.createElement('div'); tmp.innerHTML = p.description || '';
    const primero = tmp.querySelector('.md-desc-larga p, p');
    let corto = (primero ? primero.textContent : tmp.textContent).trim();
    if (corto.length > 260) corto = corto.slice(0, corto.lastIndexOf(' ', 250)) + '…';
    const tags = (p.tags || []).filter((t) => t !== p.vendor).slice(0, 4);
    qvState = { id: v.id, qty: 1, nombre };
    const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=800' : '';
    box.innerHTML = `
      <button class="md-qv-close" type="button" aria-label="Cerrar" data-md-qv-close>${ICON.close}</button>
      <div class="md-qv-media">${img ? `<img src="${img}" alt="${esc(nombre)}">` : ''}</div>
      <div class="md-qv-info">
        <p class="md-card-brand">${esc(p.vendor)}</p>
        <h2>${esc(nombre)}</h2>
        <p class="md-qv-price">${fmt(v.price / 100)}</p>
        <p class="md-qv-desc">${esc(corto)}</p>
        ${tags.length ? `<div class="md-pd-meta" style="margin:0 0 18px">${tags.map((t) => `<span>${esc(t)}</span>`).join('')}</div>` : ''}
        <p class="md-qv-label">Cantidad</p>
        <div class="md-qv-actions">
          <div class="md-qty"><button type="button" data-qv-qty="-1" aria-label="Menos">−</button><span id="qvQty">1</span><button type="button" data-qv-qty="1" aria-label="Más">+</button></div>
          ${v.available ? '<button class="md-btn md-btn-primary" type="button" style="flex:1" data-qv-add>Agregar al carrito</button>'
                        : '<button class="md-btn md-btn-secondary" type="button" style="flex:1" disabled>Agotado</button>'}
        </div>
        <a class="md-qv-full" href="${p.url || '/products/' + handle}">Ver detalles completos →</a>
      </div>`;
    open('qv', 'qvBg');
  }
  const qvClose = () => close('qv', 'qvBg');

  /* ---------- clics delegados ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    const m = t.closest('[data-md-menu]');
    if (m) {
      const accion = m.dataset.mdMenu;
      if (accion === 'close') menu(false);
      else { menu(true); if (accion === 'search') setTimeout(() => { const i = $('.md-menu input'); if (i) i.focus(); }, 320); }
      return;
    }
    if (t.closest('[data-md-drop]')) { drop(); return; }
    if (!t.closest('.md-nav-drop')) drop(false);

    const addBtn = t.closest('[data-md-add]');
    if (addBtn) { add(addBtn.dataset.mdAdd, 1, addBtn.dataset.mdName, addBtn); return; }
    const favBtn = t.closest('[data-md-fav]');
    if (favBtn) { fav(favBtn.dataset.mdFav, favBtn); return; }
    const qvOpen = t.closest('[data-md-qv]');
    if (qvOpen) {
      qv(qvOpen.dataset.mdQv); return;
    }
    if (t.closest('[data-md-qv-close]')) { qvClose(); return; }
    const qq = t.closest('[data-qv-qty]');
    if (qq && qvState) { qvState.qty = Math.max(1, qvState.qty + Number(qq.dataset.qvQty)); $('#qvQty').textContent = qvState.qty; return; }
    if (t.closest('[data-qv-add]') && qvState) {
      // cerrar ANTES de agregar: el carrito se abre y necesita el foco
      const s = qvState; qvClose(); add(s.id, s.qty, s.nombre); return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const panel = $('#dropPanel');
      if (panel && !panel.hidden) { drop(false); $('#dropBtn').focus(); return; }
      if ($('#qv') && $('#qv').classList.contains('md-open')) qvClose();
      else if ($('#menu') && $('#menu').classList.contains('md-open')) menu(false);
      return;
    }
    const openEl = document.querySelector('.md-qv.md-open, .md-menu.md-open');
    if (e.key === 'Tab' && openEl) {
      const f = openEl.querySelectorAll(FOCUSABLE); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- ficha de producto ---------- */
  function initProduct() {
    const root = $('#mdProduct'); if (!root) return;
    const main = $('#pdMain');
    const thumbs = $('#pdThumbs');
    if (thumbs && main) thumbs.addEventListener('click', (e) => {
      const b = e.target.closest('.md-pd-thumb'); if (!b) return;
      main.removeAttribute('srcset'); main.src = b.dataset.src;
      $$('.md-pd-thumb', thumbs).forEach((x) => x.classList.toggle('md-active', x === b));
    });
    let qty = 1; const qNum = $('#qNum');
    $('#qMinus').addEventListener('click', () => { qty = Math.max(1, qty - 1); qNum.textContent = qty; });
    $('#qPlus').addEventListener('click', () => { qty++; qNum.textContent = qty; });
    const addBtn = $('#pdAdd');
    const sel = $('#pdVariant');
    if (sel && addBtn) sel.addEventListener('change', () => {
      addBtn.dataset.variant = sel.value;
      const op = sel.selectedOptions[0]; if (op && op.dataset.price) $('.md-pd-price').textContent = op.dataset.price;
    });
    if (addBtn) addBtn.addEventListener('click', (e) => add(addBtn.dataset.variant, qty, addBtn.dataset.mdName, e.currentTarget));

    // preguntas frecuentes del HTML del producto → acordeón aparte, como en el prototipo
    const items = $$('#pdLong .md-faq-item');
    if (items.length) {
      $('#pdFaqs').innerHTML = items.map((it) => {
        const q = it.querySelector('h4, h3, strong'); const a = it.querySelector('p');
        return `<details class="md-faq"><summary>${esc(q ? q.textContent : '')}</summary><p>${esc(a ? a.textContent : '')}</p></details>`;
      }).join('');
      $('#faqSection').style.display = 'block';
    }
  }

  /* ---------- tienda: filtros, búsqueda y favoritos ---------- */
  function initCollection() {
    const root = $('#mdCollection'); if (!root) return;
    const params = new URLSearchParams(location.search);
    const q = (params.get('q') || '').trim();
    const soloFavs = params.get('fav') === '1';
    const cat = root.dataset.cat; // 'todos' o el handle de la categoría
    const cards = $$('#grid .md-card');
    const grid = $('#grid');
    cards.forEach((c, i) => (c.dataset.idx = i));
    let sort = 'rel', brand = 'all', price = 'all', subcat = 'all';

    // búsqueda y favoritos usan la imagen genérica y su propio título
    if (q || soloFavs) {
      const img = $('#colImg'); if (img && img.dataset.generic) { img.removeAttribute('srcset'); img.src = img.dataset.generic; }
    }
    $$('input[name="q"]').forEach((i) => { if (q) i.value = q; });

    // marcas presentes en la colección, alfabético
    const brands = [...new Set(cards.map((c) => c.dataset.brand))].filter(Boolean).sort((a, b) => a.localeCompare(b, 'es'));
    $('#brand').innerHTML = '<option value="all">Todas las marcas</option>' + brands.map((b) => `<option value="${esc(b)}">${esc(b)}</option>`).join('');

    // categoría: navega a la colección (el enlace queda compartible); búsqueda y favoritos se conservan
    $('#cat').addEventListener('change', (e) => {
      const v = e.target.value;
      const url = new URL(v === 'all' ? '/collections/all' : `/collections/${v}`, location.origin);
      if (q) url.searchParams.set('q', q);
      if (soloFavs) url.searchParams.set('fav', '1');
      location.href = url.toString();
    });

    // "Tipo" solo donde la categoría tiene más de un subtipo real (secos/húmedos, internos/externos)
    const selSub = $('#subcat');
    const tipos = [...new Set(cards.map((c) => c.dataset.sub).filter(Boolean))];
    if (cat !== 'todos' && tipos.length > 1) {
      selSub.style.display = '';
      selSub.innerHTML = '<option value="all">Todos los tipos</option>' +
        tipos.map((t) => `<option value="${esc(t)}">${esc(t.replace(/^Alimentos /, '').replace(/^Antiparasitarios /, ''))}</option>`).join('');
    }

    const selSpecies = $('#species'); selSpecies.value = pet;
    selSpecies.addEventListener('change', (e) => { pet = e.target.value; store.set('md_pet', pet); render(); });
    selSub.addEventListener('change', (e) => { subcat = e.target.value; render(); });
    $('#brand').addEventListener('change', (e) => { brand = e.target.value; render(); });
    $('#price').addEventListener('change', (e) => { price = e.target.value; render(); });
    $('#sort').addEventListener('change', (e) => { sort = e.target.value; render(); });

    function limpiar() {
      brand = 'all'; price = 'all'; subcat = 'all'; pet = 'todos'; store.set('md_pet', pet);
      $('#brand').value = 'all'; $('#price').value = 'all'; selSub.value = 'all'; selSpecies.value = 'todos';
      render();
    }
    $('#clear').addEventListener('click', limpiar);
    $('#emptyClear').addEventListener('click', limpiar);
    document.addEventListener('md:favs', () => { if (soloFavs) render(); });

    const inPrice = (p) => {
      if (price === 'all') return true;
      const [lo, hi] = price.split('-');
      return hi === '' ? p >= +lo : p >= +lo && p < +hi;
    };
    const match = (c) => {
      const t = c.dataset.text || '';
      return q.toLowerCase().split(/\s+/).filter(Boolean).every((w) => t.includes(w));
    };

    const titleBase = $('#colTitle').textContent;
    function render() {
      let list = cards.slice();
      if (soloFavs) list = list.filter((c) => favs.includes(c.dataset.handle));
      if (pet !== 'todos') list = list.filter((c) => c.dataset.pet === pet || c.dataset.pet === 'ambos');
      if (q) list = list.filter(match);
      if (subcat !== 'all') list = list.filter((c) => c.dataset.sub === subcat);
      if (brand !== 'all') list = list.filter((c) => c.dataset.brand === brand);
      list = list.filter((c) => inPrice(+c.dataset.price));
      if (sort === 'az') list.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name, 'es'));
      else if (sort === 'asc') list.sort((a, b) => a.dataset.price - b.dataset.price);
      else if (sort === 'desc') list.sort((a, b) => b.dataset.price - a.dataset.price);
      else list.sort((a, b) => a.dataset.idx - b.dataset.idx);

      cards.forEach((c) => (c.hidden = true));
      list.forEach((c) => { c.hidden = false; grid.appendChild(c); });

      $('#colTitle').textContent = soloFavs ? 'Tus favoritos' : q ? `Resultados para "${q}"` : titleBase;
      $('#colCount').textContent = list.length + (list.length === 1 ? ' producto' : ' productos');

      const vacio = !list.length;
      $('#empty').style.display = vacio ? 'block' : 'none';
      if (vacio) {
        $('#emptySub').textContent = soloFavs ? 'Toca el corazón de un producto para guardarlo aquí.'
          : q ? 'Prueba con el nombre de la marca o el tipo de producto.' : 'Prueba quitando un filtro.';
        const wa = $('#emptyWa'); const base = (wa.dataset.waBase || '').trim();
        wa.href = base + encodeURIComponent(q ? `Hola Madagascar, ¿tienen ${q}?` : 'Hola Madagascar, busco un producto y no lo encuentro en la web');
      }
      const n = [brand !== 'all', price !== 'all', subcat !== 'all', pet !== 'todos'].filter(Boolean).length;
      $('#clear').style.display = n ? 'inline-flex' : 'none';
      const btn = $('#filtrosBtn');
      btn.innerHTML = ICON.filtro + (n ? ` Filtros · ${n}` : ' Filtros');
      btn.classList.toggle('md-active', n > 0);
    }

    const toolbar = $('#toolbar');
    $('#filtrosBtn').addEventListener('click', () => {
      const abierto = toolbar.classList.toggle('md-filtros-open');
      $('#filtrosBtn').setAttribute('aria-expanded', String(abierto));
    });
    render();
  }

  /* ---------- contacto: el formulario abre WhatsApp ---------- */
  function initContacto() {
    const f = $('#mdContactForm'); if (!f) return;
    f.addEventListener('submit', (e) => {
      e.preventDefault();
      const nombre = $('#cfNombre').value.trim(), tema = $('#cfTema').value, msg = $('#cfMsg').value.trim();
      window.open((f.dataset.waBase || '').trim() + encodeURIComponent(`Hola Madagascar, soy ${nombre}. Consulta sobre: ${tema}. ${msg}`), '_blank');
    });
  }

  /* ---------- precarga: la foto grande y la vista rápida ya están listas al hacer clic ---------- */
  const precargadas = new Set();
  function precargar(url) { if (!url || precargadas.has(url)) return; precargadas.add(url); const i = new Image(); i.decoding = 'async'; i.src = url; }
  const jsonCache = {};
  const _fetch = window.fetch.bind(window);
  function prefetchQV(handle) {
    if (jsonCache[handle]) return;
    jsonCache[handle] = _fetch(`/products/${handle}.js`).then((r) => r.json()).then((p) => {
      if (p.featured_image) precargar(p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=800');
      return p;
    }).catch(() => { delete jsonCache[handle]; });
  }
  document.addEventListener('pointerover', (e) => {
    const m = e.target.closest && e.target.closest('[data-md-qv]');
    if (m) prefetchQV(m.dataset.mdQv);
  }, { passive: true });
  function precargarGaleria() {
    const go = () => $$('.md-pd-thumb').forEach((b) => precargar(b.dataset.src));
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2000 }); else setTimeout(go, 1200);
  }

  /* ---------- carrito: regalos por meta (md-metas.liquid + descuentos automáticos en el admin) ----------
     El regalo es una línea normal con la propiedad oculta _md_regalo. El script la agrega cuando el
     subtotal SIN regalos alcanza la meta y la quita cuando baja; el descuento automático la deja en $0. */
  let regalosOcupado = false;
  async function syncRegalos(abrir) {
    const metas = window.MD_REGALOS || [];
    if (!metas.length || regalosOcupado) return false;
    regalosOcupado = true;
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const esRegalo = (l) => l.properties && l.properties._md_regalo;
      const base = cart.items.filter((l) => !esRegalo(l)).reduce((t, l) => t + l.final_line_price, 0);
      const cambios = {}; const altas = [];
      // Un solo regalo por pedido: el de la meta más alta alcanzada. Shopify no deja que dos descuentos
      // «compra X y llévate Y» usen los mismos productos para calificar, así que el regalo SUBE de nivel.
      const ganada = metas.filter((m) => base >= m.min).sort((x, y) => y.min - x.min)[0];
      metas.forEach((m) => {
        const linea = cart.items.find((l) => esRegalo(l) && l.properties._md_regalo === m.key);
        const toca = ganada && ganada.key === m.key;
        if (toca && !linea) altas.push({ id: m.variant, quantity: 1, properties: { _md_regalo: m.key } });
        if (linea && !toca) cambios[linea.key] = 0;
        else if (linea && linea.quantity > 1) cambios[linea.key] = 1;
      });
      if (!altas.length && !Object.keys(cambios).length) return false;
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer ? drawer.getSectionsToRender().map((x) => x.id) : [];
      const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign(body, sections.length ? { sections, sections_url: location.pathname } : {})) }).then((r) => r.json());
      let res = null;
      if (Object.keys(cambios).length) res = await post('/cart/update.js', { updates: cambios });
      if (altas.length) { res = await post('/cart/add.js', { items: altas }); if (altas.length) toast(Object.keys(cambios).length ? '¡Subiste de nivel tu regalo!' : '¡Desbloqueaste un regalo!'); }
      const pagina = document.querySelector('cart-items:not(cart-drawer-items)');
      if (pagina && typeof pagina.onCartUpdate === 'function') pagina.onCartUpdate();
      else if (drawer && res && res.sections && (abrir || drawer.classList.contains('active'))) drawer.renderContents(res);
      else if (res && res.sections && res.sections['cart-icon-bubble']) {
        const b = document.getElementById('cart-icon-bubble');
        if (b) b.innerHTML = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
      }
      return true;
    } catch (e) { return false; } finally { regalosOcupado = false; }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'md-regalos') setTimeout(() => syncRegalos(false), 50); });
  }

  /* ---------- carrito: «Agrégale a tu pedido» (md-upsell.liquid) ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest && e.target.closest('.md-upsell-add');
    if (!b || b.disabled) return;
    b.disabled = true; b.classList.add('md-cargando');
    const card = b.closest('.md-upsell-card');
    const nombre = card && card.querySelector('.md-upsell-nom') ? card.querySelector('.md-upsell-nom').textContent.trim() : '';
    await add(b.dataset.variant, 1, nombre, null);
    const pagina = document.querySelector('cart-items:not(cart-drawer-items)');
    if (pagina && typeof pagina.onCartUpdate === 'function') pagina.onCartUpdate();
    b.disabled = false; b.classList.remove('md-cargando');
  });

  /* ---------- cuándo llega el despacho (md-entrega.liquid), con la hora de Chile ----------
     En 24 horas, al día siguiente (Jania, 20-oct); el domingo no se reparte: lo del sábado llega el lunes.
     El carrito lateral se redibuja con cada cambio y su HTML nuevo no corre scripts: por eso un observer. */
  function textoEntrega() {
    const dia = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', weekday: 'short' }).format(new Date());
    return dia === 'Sat' ? 'Compra hoy y te llega el lunes' : 'Compra hoy y te llega mañana';
  }
  function syncEntrega() {
    const t = textoEntrega();
    $$('[data-md-entrega]').forEach((el) => { if (el.textContent !== t) el.textContent = t; });
  }
  function initEntrega() {
    syncEntrega();
    new MutationObserver((ms) => { if (ms.some((m) => m.addedNodes.length)) syncEntrega(); }).observe(document.body, { childList: true, subtree: true });
  }

  function init() { syncRegalos(false); syncFavs(); initProduct(); precargarGaleria(); initCollection(); initContacto(); initEntrega(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MD = { add, toast, fav, qv };
})();
